var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "quantity-header" },
      [
        _c("el-checkbox", {
          model: {
            value: _vm.quantity.status,
            callback: function($$v) {
              _vm.$set(_vm.quantity, "status", $$v)
            },
            expression: "quantity.status"
          }
        }),
        _vm._v(" "),
        _c("label", { staticClass: "contactum-label" }, [
          _vm._v(" " + _vm._s("Use Quantity") + " ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.quantity.status
      ? _c("div", [
          _c(
            "div",
            { staticClass: "quantity-input-item" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(" " + _vm._s("Minimum Quantity") + " ")
              ]),
              _vm._v(" "),
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  min: 0,
                  placeholder: "Max",
                  "controls-position": "right"
                },
                model: {
                  value: _vm.quantity.min,
                  callback: function($$v) {
                    _vm.$set(_vm.quantity, "min", $$v)
                  },
                  expression: "quantity.min"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "quantity-input-item" },
            [
              _c("label", { staticClass: "contactum-label" }, [
                _vm._v(" " + _vm._s("Maximum Quantity") + " ")
              ]),
              _vm._v(" "),
              _c("el-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  min: _vm.quantity.min || 0,
                  placeholder: "Max",
                  "controls-position": "right"
                },
                model: {
                  value: _vm.quantity.max,
                  callback: function($$v) {
                    _vm.$set(_vm.quantity, "max", $$v)
                  },
                  expression: "quantity.max"
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }